import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useActividadesEconomicasContext } from "../actividades-economicas-context";

export function ActividadesEconomicasTable() {
  const navigate = useNavigate();

  const {
    actividadesEconomicas,
    deleteActividadEconomica,
    verifyActividadEconomica,
  } = useActividadesEconomicasContext();

  return (
    <Paper
      className="animate__animated animate__fadeIn"
      sx={{ padding: 1 }}
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Actividades económicas</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!actividadesEconomicas.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Actividad económica",
                  // "Estado",
                  // "Opciones"
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {actividadesEconomicas.map((actividad, i) => (
                <TableRow key={actividad.actividad_id}>
                  <TableCell>{i + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        {actividad.actividad_economica_descripcion}
                      </Typography>

                      {!!actividad.actividad_economica_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>

                    <Typography variant="body2">
                      <strong>Detalles: </strong>
                      {actividad.actividad_economica_detalles}
                    </Typography>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!actividad.actividad_economica_verificada
                          ? "Verificada"
                          : "Pendiente"
                      }
                      color={
                        !!actividad.actividad_economica_verificada
                          ? "success"
                          : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!actividad.actividad_economica_verificada ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyActividadEconomica({
                                actividadId: actividad.actividad_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${actividad.actividad_id}/edit`)
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteActividadEconomica({
                                actividadId: actividad.actividad_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin actividades económicas
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
